import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'
import { faCog } from '@fortawesome/pro-regular-svg-icons/faCog'

import BackButton from '../BackButton'

const Title = styled.h2`
    font-size: 1rem;
    margin: 0;
    color: #fff;
    display: flex;
    align-items: center;

    a {
        width: 30px;
        cursor: pointer;

        &.back {
            color: #c0c0c0;
        }
    }

    .faded {
        opacity: 0.4;
    }
`

const PageTitle = ({ title, showSettings, setShowSettings, contentType }) => (
    <Title>
        <BackButton contentType={contentType} />

        <a
            role="button"
            onClick={() => setShowSettings(!showSettings)}
            data-testid="content-toggle-settings"
        >
            <FontAwesomeIcon icon={showSettings ? faTimes : faCog} />
        </a>
        {title.length > 0 ? <span>{title}</span> : <span className="faded">(Untitled Page)</span>}
    </Title>
)
export default PageTitle
